var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:[
    // ResizableMixin
    'image-thumbnail-crop-frame',
    // Crop
    'overflow-hidden',
    // Center
    'flex',
    'items-center',
    'justify-center',
    _vm.bgColorClass,
  ],style:({
    ..._vm.overflowBorderRadiusTransformFixStyle,
    width: _vm.dimensions.cropFrameWidthString,
    height: _vm.dimensions.cropFrameHeightString,
    'background-color': _vm.placeholderColorValue,
  }),attrs:{"data-aspect-ratio":_vm.dimensions.cropFrameAspectRatio}},[(!_vm.error)?_c('base-image',{class:[
      // ResizableMixin
      'image-thumbnail-image',
      _vm.flipDirection === 'horizontal' && 'transform scale-x-[-1]',
      _vm.flipDirection === 'vertical' && 'transform scale-y-[-1]',
    ],style:(_vm.resizeStrategy === 'fit'
        ? {
            width: _vm.dimensions.imageElementWidthString,
            height: _vm.dimensions.imageElementHeightString,
            objectFit: 'cover',
            objectPosition: _vm.objectPosition,
          }
        : {}),attrs:{"src":_vm.url,"alt":_vm.title,"data-cy":_vm.dataCy,"height":_vm.dimensions.imageElementHeight,"width":_vm.dimensions.imageElementWidth,"loading":_vm.lazyLoading ? 'lazy' : 'eager'},on:{"load":_vm.onLoad,"error":_vm.onError}}):(_vm.fallbackToPlaceholder)?_c('base-image',{class:[
      // ResizableMixin
      'image-thumbnail-image',
    ],style:(_vm.resizeStrategy === 'fit'
        ? {
            width: _vm.dimensions.imageElementWidthString,
            height: _vm.dimensions.imageElementHeightString,
            objectFit: 'cover',
          }
        : {}),attrs:{"src":_vm.errorPlaceholderImage,"alt":_vm.title,"data-cy":_vm.dataCy,"height":_vm.dimensions.imageElementHeight,"width":_vm.dimensions.imageElementWidth,"loading":_vm.lazyLoading ? 'lazy' : 'eager'}}):_c('p',[_vm._v(_vm._s(_vm.title))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }